import { render, staticRenderFns } from "./LimitSettingsPreview.vue?vue&type=template&id=2badf30a&scoped=true&"
import script from "./LimitSettingsPreview.vue?vue&type=script&lang=js&"
export * from "./LimitSettingsPreview.vue?vue&type=script&lang=js&"
import style0 from "./LimitSettingsPreview.vue?vue&type=style&index=0&id=2badf30a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2badf30a",
  null
  
)

export default component.exports